import React, { Component } from 'react';
import moment from 'moment';
import Spinner from 'src/ui/library/Spinner/Spinner';
import WarningIcon from '@material-ui/icons/Warning';
import ContentParser from 'src/ui/library/ContentParser';
import DocumentsLandingContainer from 'src/ui/features/Documents/containers/DocumentsLandingContainer';
import download from 'downloadjs';
import { openDocumentAPI } from 'src/services/documents.service';
import mime from 'mime-types';
import { getGroupTaskDetails, getTemplateDetails, downloadTemplateAPI } from 'src/services/tasks.service.js';
import RelatedEntitiesLanding from 'src/ui/library/RelatedEntities';
import Button from 'src/ui/library/Button';
import { getProfileContactEmploymentHistoryApi, upsertProfileContactEmploymentHistorySalaryApi } from 'src/services/profile.service';
import GetAppIcon from '@material-ui/icons/GetApp';
import { CASE_DATA_MENUTYPES } from 'src/constants/constants';

class TaskPres extends Component {
  constructor(props) {
    super(props);
    this.state = {
      component: null,
      taskDetails: null,
      isFormComplete: false,
      subMenuType: '',
      tabIndex: 0,
      templateData: [],
      isTaskLoading: false,
      menuTypeCode: null,
    };
  }

  componentDidMount() {
    const {
      match: {
        params: { pageId },
      },
      caseDatacollectMenu: { menuDetails },
    } = this.props;

    if (menuDetails && menuDetails.length > 0) {
      let index = 0;
      let status = null;
      for (let i = 0; i < menuDetails.length; i++) {
        const data = menuDetails[i].subMenu.find(x => x.pageId === pageId);
        if (data) {
          index = i;
          status = data.pageState;
          this.setState({ taskDetails: data, tabIndex: i, menuTypeCode: menuDetails[i].menuTypeCode });
          break;
        }
      }
      const isTaskDocsCompleted = status && status.toLowerCase() === 'complete';
      this.getAllTaskDetails(pageId, index, isTaskDocsCompleted);
    }
  }

  componentDidUpdate(prevState) {
    const {
      match: {
        params: { pageId },
      },
      caseDatacollectMenu: { menuDetails },
      setCompletedStatus,
      setDocumentTaskStatusState,
      saveCurrentTaskForm,
      setCheckboxChecked,
    } = this.props;

    let index = 0;
    let status = null;
    if (prevState && prevState.match.params.pageId !== pageId) {
      for (let i = 0; i < menuDetails.length; i++) {
        const data = menuDetails[i].subMenu.find(x => x.pageId === pageId);
        if (data) {
          index = i;
          status = data.pageState;
          this.setState({ taskDetails: data, tabIndex: i, menuTypeCode: menuDetails[i].menuTypeCode });
          break;
        }
      }
      //saving the left panel tab changes
      if (prevState) {
        const {
          match: {
            params: { pageId: prvPageId, caseId: prvCaseId },
          },
          caseDatacollectMenu: { menuDetails: prevMenuDetails },
          additionalInfo,
        } = prevState;
        let prevTask = null;
        if (prevMenuDetails && prevMenuDetails.length > 0) {
          for (let i = 0; i < prevMenuDetails.length; i++) {
            const data = prevMenuDetails[i].subMenu.find(x => x.pageId === pageId);
            if (data) {
              prevTask = data;
              break;
            }
          }
          if (
            prevTask &&
            prevTask.pageState &&
            prevTask.pageState.toLowerCase() === 'incomplete' &&
            additionalInfo.typeName === 'ContentParser'
          ) {
            saveCurrentTaskForm(prvCaseId, prvPageId);
          }
        }
      }
      const isTaskDocsCompleted = status && status.toLowerCase() === 'complete';
      setCompletedStatus(false);
      setDocumentTaskStatusState(false);
      setCheckboxChecked(false);
      this.getAllTaskDetails(pageId, index, isTaskDocsCompleted);
    }
  }

  getAllTaskDetails = (taskId, tabIndex, isTaskDocsCompleted) => {
    this.setState({ isTaskLoading: true });
    const { getAdditionalInfoForCurrentTask, setCheckboxChecked } = this.props;
    getGroupTaskDetails(taskId).then(
      res => {
        if (res && !res.error && !res.errors) {
          const { referencingEntity, referencingId, typeName, relatedEntityDetails } = res;
          getAdditionalInfoForCurrentTask({
            referencingEntity,
            referencingId,
            typeName,
          });
          let component = null;
          this.setState({ subMenuType: typeName });
          if (typeName === 'RelatedEntity') {
            component = (
              <RelatedEntitiesLanding
                key={tabIndex}
                isTaskDocsCompleted={isTaskDocsCompleted}
                topLevelRecordId={relatedEntityDetails.id}
                parentRecordId={relatedEntityDetails.id}
                parentEntitySetName="contacts"
                parentEntityName="contact"
                relationshipName={relatedEntityDetails.relationshipName}
                additionalProps={this.getAdditionalPropsForRelatedEntities(relatedEntityDetails.relationshipName)}
                getAdditionalPropsForRelatedEntities={this.getAdditionalPropsForRelatedEntities}
                area="profile"
              />
            );
          } else if (typeName === 'ContentParser') {
            this.setState({ isTaskContentParser: true });
            const filterPageDataForHostCompany = pageData => {
              const { hostRows, caseHeaderDetails } = this.props;
              const caseServiceCountry = caseHeaderDetails && caseHeaderDetails.serviceCountry.toLowerCase();
              if (hostRows && hostRows.length > 0) {
                let filteredRows = hostRows.filter(ele => ele.countryName.valueOf().toLowerCase() === caseServiceCountry);
                let RemainingRows = hostRows.filter(ele => ele.countryName.valueOf().toLowerCase() !== caseServiceCountry);
                let OrderedRows = [...filteredRows, ...RemainingRows];
                return {
                  ...pageData,
                  lookUps: {
                    ...pageData.lookUps,
                    ey_hostcompanyid: OrderedRows,
                  },
                };
              }

              return { ...pageData };
            };
            const { contentParserDetails } = res;
            component = (
              <ContentParser
                key={tabIndex}
                readOnly={isTaskDocsCompleted}
                data={filterPageDataForHostCompany(contentParserDetails)}
                showLabels={false}
                numberOfColumns={3}
                debug={false}
                onChange={this.onFormChange}
              />
            );
          } else if (typeName === 'DocumentUpload') {
            getTemplateDetails(taskId).then(res => {
              if (res && !res.error && !res.errors) {
                this.setState({
                  templateData: res,
                });
              }
            });
            const { documentUploadDetails } = res;
            component = (
              <DocumentsLandingContainer
                hideLandingHeader={true}
                isTaskDocsCompleted={isTaskDocsCompleted}
                setCheckboxChecked={setCheckboxChecked}
                isTaskFlow={true}
                docTaskId={taskId}
                taskFlowProps={documentUploadDetails}
                {...this.props}
              />
            );
          }
          this.setState({
            isTaskLoading: false,
            component,
          });
        } else {
          let errorMsg = '';
          if (res.error) {
            errorMsg += res.error.message;
          } else if (res.errors) {
            res.errors.forEach(error => {
              errorMsg += error.message + '\n';
            });
          } else {
            errorMsg = '';
          }
          this.props.enqueueSnackbar('Error: ' + errorMsg, {
            variant: 'error',
          });
          this.setState({ isLoading: false, isError: true });
        }
      },
      error => {
        this.props.enqueueSnackbar('Error: ' + error.message, {
          variant: 'error',
        });
        this.setState({ isLoading: false, isError: true });
      },
    );
  };

  getAdditionalPropsForRelatedEntities = relationshipName => {
    let fetch,
      get,
      upsert,
      del = null;
    let relatedEntities = [];
    let sortColumn = '';
    let readOnly = false;
    let onValidate = null;
    let displayName = '';
    let tabLabel = '';

    const dateErrorValidation = [
      'ey_contact_ey_address_ContactId',
      'ey_contact_ey_contactcitizenship_ContactId',
      'ey_contact_ey_contacteducation_ContactId',
      'ey_contact_ey_contactemploymenthistory_ContactId',
      'ey_contact_ey_contactidentificationnumber_ContactId',
      'ey_contact_ey_contacttravelhistory_ContactId',
      'ey_contact_ey_contactinsurance',
      'ey_relationship_OriginatingContactId_Cont',
      'ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId',
    ];

    if (dateErrorValidation.includes(relationshipName)) {
      onValidate = (fields, setErrorFn) => {
        const {
          ey_startdate,
          ey_enddate,
          ey_effectivestartdate,
          ey_effectiveenddate,
          ey_travelstartdate,
          ey_travelenddate,
          ey_issuedate,
        } = fields;
        let error = false;

        if (
          ((ey_startdate || ey_issuedate) && ey_enddate) ||
          (this.state.isUpcomingTravel && ey_travelstartdate) ||
          (ey_effectivestartdate && ey_effectiveenddate) ||
          (ey_travelstartdate && ey_travelenddate)
        ) {
          let s;
          let e;

          if (
            (ey_startdate && ey_startdate.length === 11) ||
            (ey_effectivestartdate && ey_effectivestartdate.length === 11) ||
            (ey_travelstartdate && ey_travelstartdate.length === 11) ||
            (ey_issuedate && ey_issuedate.length === 11)
          ) {
            s = moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'DD-MMM-YYYY').format('YYYYMMDD');
            const setTravelStartErrorDate = ey_travelstartdate && 'ey_travelstartdate';
            if (this.state.isUpcomingTravel && moment(s).diff(moment(), 'days') < 0) {
              const ts_errorMsg = (
                <span className="error-msg">
                  <WarningIcon />
                  <b>Start Date cannot be less than current date.</b>
                </span>
              );
              setErrorFn(setTravelStartErrorDate, true, ts_errorMsg);
              error = true;
            }
          }
          if (
            (ey_startdate && ey_startdate.length === 11) ||
            (ey_effectivestartdate && ey_effectivestartdate.length === 11) ||
            (ey_travelstartdate && ey_travelstartdate.length === 11) ||
            (ey_issuedate && ey_issuedate.length === 11) ||
            (ey_enddate && ey_enddate.length === 11) ||
            (ey_effectiveenddate && ey_effectiveenddate.length === 11) ||
            (ey_travelenddate && ey_travelenddate.length === 11)
          ) {
            s = moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'DD-MMM-YYYY').format('YYYYMMDD');
            e = moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'DD-MMM-YYYY').format('YYYYMMDD');
          } else {
            if (
              (ey_startdate && ey_startdate.length === 10) ||
              (ey_effectivestartdate && ey_effectivestartdate.length === 10) ||
              (ey_travelstartdate && ey_travelstartdate.length === 10) ||
              (ey_issuedate && ey_issuedate.length === 10) ||
              (ey_enddate && ey_enddate.length === 10) ||
              (ey_effectiveenddate && ey_effectiveenddate.length === 10) ||
              (ey_travelenddate && ey_travelenddate.length === 10)
            ) {
              s = moment(ey_startdate || ey_effectivestartdate || ey_travelstartdate || ey_issuedate, 'YYYY-MM-DD').format('YYYYMMDD');
              e = moment(ey_enddate || ey_effectiveenddate || ey_travelenddate, 'YYYY-MM-DD').format('YYYYMMDD');
            }
          }
          const setErrorDate =
            (ey_enddate && 'ey_enddate') || (ey_effectiveenddate && 'ey_effectiveenddate') || (ey_travelenddate && 'ey_travelenddate');
          if (moment(e).diff(moment(s), 'days') < 0) {
            const errorMsg = (
              <span className="error-msg">
                <WarningIcon />
                <b>End Date cannot be before Start Date.</b>
              </span>
            );
            setErrorFn(setErrorDate, true, errorMsg);
            error = true;
          }
        }
        return error;
      };
    }
    if (relationshipName === 'ey_contact_ey_contactemploymenthistory_ContactId') {
      get = getProfileContactEmploymentHistoryApi;
      relatedEntities = {
        parentEntitySetName: 'ey_contactemploymenthistories',
        parentEntityName: 'ey_contactemploymenthistory',
        relationships: ['ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId'],
      };
    } else if (relationshipName === 'ey_ey_contactemploymenthistory_ey_contactemploymenthistorysalary_ContactEmploymentHistoryId') {
      upsert = upsertProfileContactEmploymentHistorySalaryApi;
      displayName = 'Employment Salary';
      tabLabel = 'Employment Salary';
    }

    return {
      fetch,
      get,
      upsert,
      del,
      displayName,
      tabLabel,
      relatedEntities,
      sortColumn,
      readOnly,
      onValidate,
    };
  };

  onFormChange = formData => {
    const { updateCurrentTaskFormValues } = this.props;
    if (formData.isFormComplete) {
      this.setState({ isFormComplete: true });
    } else {
      this.setState({ isFormComplete: false });
    }
    updateCurrentTaskFormValues(formData);
  };

  handleClick = (e, type) => {
    const { handleSave, checkComplete } = this.props;
    if (type === 'submit') {
      checkComplete(e, true);
      handleSave();
    }
  };

  onCancelModal = e => {
    const { checkComplete } = this.props;
    checkComplete(e, false);
  };

  downloadBatchTemplate = item => {
    const { taskId } = this.props;
    (item.documentType === 'Document' ? openDocumentAPI(item.documentKey) : downloadTemplateAPI(item.documentId, taskId)).then(
      res => {
        if (res && !res.error && !res.errors) {
          let data = res.documentData;
          let fileName = res.fileName;
          let type = mime.lookup(fileName);
          download(atob(data), fileName, type);
        } else {
          let errorMsg = ' - ';
          if (res.error) {
            errorMsg += res.error.message;
          } else if (res.errors) {
            res.errors.forEach(error => {
              errorMsg += error.message + '\n';
            });
          } else {
            errorMsg = '';
          }
          this.props.showNotification('Download failed' + errorMsg, {
            variant: 'error',
          });
        }
      },
      error => {
        this.props.showNotification('Download failed - ' + error.message, {
          variant: 'error',
        });
      },
    );
  };

  render() {
    const { isLoading, isCompleted, isCheckboxChecked } = this.props;
    const { component, subMenuType, templateData, taskDetails, isTaskLoading, menuTypeCode, isFormComplete } = this.state;

    if (!taskDetails) return;
    return (
      <div className="task-flow-content-container">
        {isTaskLoading || isLoading ? (
          <div className="task-flow-spinner">
            <Spinner size={70} />
          </div>
        ) : (
          <div>
            <div className="header">
              <div className="subject">{taskDetails.menuName}</div>
              <div className="description">
                {taskDetails.taskDescription}
                {/* <Scrollbar autoHeight={false} autoHide={false}>
                  {taskDetails.taskDescription}
                </Scrollbar> */}
              </div>
              <div className="divider-line" />
            </div>
            {menuTypeCode !== CASE_DATA_MENUTYPES.REVIEW && (
              <div style={{ display: 'flex' }}>
                {templateData.length !== 0 && <span>Document(s) to download:</span>}
                {templateData &&
                  templateData.map(template => {
                    return (
                      <a
                        className="ssi-download-template-link"
                        style={{ cursor: 'pointer' }}
                        onClick={() => this.downloadBatchTemplate(template)}>
                        <GetAppIcon style={{ color: '#155CB4' }} />
                        <span
                          className="document-name-link"
                          style={{
                            position: 'relative',
                            bottom: '6px',
                            margin: '0 15px 0 5px',
                          }}>
                          {template.documentName}
                        </span>
                      </a>
                    );
                  })}
              </div>
            )}
            <div className="component">{component}</div>
            <section className="task-document-actions-container">
              <div className="actions-button-container">
                <div className="button-save"></div>
                <div className="button-next-previous">
                  <Button
                    styleType="primary"
                    disabled={
                      isCompleted ||
                      (menuTypeCode === CASE_DATA_MENUTYPES.REVIEW && subMenuType === 'ContentParser' && !isFormComplete) ||
                      (!isCheckboxChecked && subMenuType === 'DocumentUpload') ||
                      (taskDetails.pageState && taskDetails.pageState.toLowerCase() === 'complete')
                    }
                    onClick={e => this.handleClick(e, 'submit')}
                    className="next-btn">
                    {'Submit'}
                  </Button>
                </div>
              </div>
            </section>
          </div>
        )}
      </div>
    );
  }
}

export default TaskPres;
